import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';

import { Icon } from '@uncinc/uncinc-react-kitchen-sink';

import Card from '../../../../components/Card';

import './style.scss';

interface ProfileCardProps {
  title: string;
  subtitle?: string;
  image: React.ReactNode;
  link?: string;
  departments?: string[];
  headOfDepartment?: boolean;
  minimal?: boolean;
  isExternal?: boolean;
}

const ProfileCard: React.FC<ProfileCardProps> = ({
  title,
  subtitle,
  image,
  link,
  departments,
  headOfDepartment = false,
  minimal = false,
  isExternal = false,
}) => {
  const { t } = useTranslation();
  const classes = c('ProfileCard', {
    ProfileCard__regular: !minimal,
    ProfileCard__minimal: minimal,
  });

  return (
    <Card className={classes} {...link && { withLink: true }}>
      <Card.Content>
        <div className="Card__content__text">
          {link ? (
            <Card.Link href={link}>
              <Card.Title title={title} />
              {isExternal && <Icon name="arrow_outward" flair="outlined" />}
              {(!isExternal && minimal) && <Icon name="chevron_right" flair="outlined" />}
            </Card.Link>
          ) : (
            <Card.Title title={title} />
          )}

          {((departments && departments.length > 0) || headOfDepartment || subtitle) && (
            <div className="Card__content__labels">
              {(departments && departments.length > 0) && (
                <Card.Tags
                  tags={departments.map((theme) => ({ name: theme, type: 'departments' }))}
                />
              )}

              {headOfDepartment && (
                <Card.Tags
                  tags={[{ name: t('taxonomies.departments.head'), type: 'staff' }]}
                />
              )}

              {subtitle && (
                <Card.Subtitle
                  subtitle={(
                    <p className="u-truncate--3 body--small">
                      {subtitle}
                    </p>
                  )}
                />
              )}
            </div>
          )}
        </div>

        <Card.Image
          image={image}
        />
      </Card.Content>
    </Card>
  );
};

export default ProfileCard;
